import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import { COLORS } from 'src/utils/cubiButtonUtils';

const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton
      size="medium"
      color="secondary"
      onClick={onClick}
      style={{ 
        backgroundColor: COLORS.RED, 
        border: '2px solid rgb(55, 55, 55)', 
        cursor: 'pointer', 
        width: "42px", 
        height: "42px", 
        position: 'absolute', 
        right: '8px', 
        top: '8px',
      }}
    >
      <CloseIcon style={{color: "#fff"}}/>
    </IconButton>
  );
};

const ConfirmButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton
      size="medium"
      color="secondary"
      onClick={onClick}
      style={{ backgroundColor: COLORS.GREEN, border: '2px solid rgb(55, 55, 55)', cursor: 'pointer', width: "42px", height: "42px"}}
    >
      
      <CheckIcon style={{color: "#fff"}}/>
    </IconButton>
  );
};

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    backgroundColor: '#EFF7FF',
    border: '4px solid #373737',
    borderRadius: '8px',
    position: 'relative',
    maxWidth: '80vw',
    overflow: 'visible',
  },
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontSize: '2rem',
  padding: "8px",
}));

interface I4kDialogProps {
  title: string;
  showModal: boolean;
  showConfirmButton?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  minWidth?: string;
}

const I4kDialog: React.FC<I4kDialogProps> = ({
  title,
  showModal,
  showConfirmButton = true,
  onClose,
  onConfirm,
  children,
  minWidth
}) => {
  return (
    <StyledDialog open={showModal} onClose={onClose}>
      <StyledDialogTitle>
        <Typography variant="h4">{title}</Typography>
        <CloseButton onClick={onClose} />
      </StyledDialogTitle>
      <DialogContent style={{width: minWidth}}>{children}</DialogContent>
      {showConfirmButton && (
        <DialogActions>
          <ConfirmButton onClick={onConfirm} />
        </DialogActions>
      )}
    </StyledDialog>
  );
};

export default I4kDialog;